export default "__VITE_ASSET__BxD$$TfV__"